import React, { useEffect } from "react";

import {useStoreActions, useStoreState} from 'easy-peasy';
import { Col, Row } from "react-bootstrap";

import ApkFormComponent from "../../components/apks/ApkFormComponent";
import useBackButton from "../../hooks/useBackButton";
import { useLocation } from "react-router-dom";

const CreateApkPage = () => {
	const {createApk} =  useStoreActions((actions) => actions.apks);
    const { packageById, isFetchingOnePackage } = useStoreState((state) => state.packages);
    const { fetchPackageById } = useStoreActions(actions => actions.packages);
    const location = useLocation();

    const { backButtonComponent } = useBackButton();

    useEffect(() => {
        let params = new URLSearchParams(location.search);
        let packageUniqueId = params.get("packageUniqueId");

        !isFetchingOnePackage && packageUniqueId && packageById?.uniqueId !== packageUniqueId && fetchPackageById(packageUniqueId)
    }, []);

	return (
		<div className="container p-2">
			<Row className="mb-3">
				<Col className="d-flex justify-content-between align-items-center">
                    <h2>Ajout d'un APK à l'application {packageById && packageById.name}</h2>
					{backButtonComponent}
				</Col>
			</Row>
            {
                <ApkFormComponent 
					actionFn={createApk}
				/>
            }
		</div>
	);
};

export default CreateApkPage;
